import { getServices } from '~/db/services';

export const useGamingSyncGet = () => {
  const { $db } = useNuxtApp();
  const { gamingsService } = getServices($db);
  const ids = ref<string[]>();
  const context = useContextStore();

  watchEffect(() => {
    if (context.memberId) {
      ids.value = [context.userId];
    } else {
      ids.value = [];
    }
  });

  const request = ref<() => Promise<GamingSchema[]>>(async () => {
    try {
      return gamingsService.findByIds(ids.value);
    } catch (e) {
      globalThis.$logger.info('useGamingSyncGet :: error', e);
    }
  });

  const { value: gaming, release } = useLiveQuery<GamingSchema[]>(
    request.value,
    ids
  );

  return { gaming };
};
